var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullScreenCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_758_15241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 24.5,
    stroke: "#EBEBEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9924 35.5057V39.003C52.9924 39.2681 52.8871 39.5222 52.6997 39.7096C52.5123 39.897 52.2582 40.0023 51.9932 40.0023C51.7282 40.0023 51.474 39.897 51.2866 39.7096C51.0992 39.5222 50.9939 39.2681 50.9939 39.003V35.5057C50.9939 35.057 50.942 35.0061 50.4943 35.0061H46.997C46.7319 35.0061 46.4778 34.9008 46.2904 34.7134C46.103 34.526 45.9977 34.2718 45.9977 34.0068C45.9977 33.7418 46.103 33.4877 46.2904 33.3003C46.4778 33.1129 46.7319 33.0076 46.997 33.0076H50.4943C50.8293 32.9804 51.1661 33.0264 51.4815 33.1423C51.7969 33.2583 52.0834 33.4414 52.321 33.679C52.5586 33.9166 52.7417 34.2031 52.8577 34.5185C52.9736 34.8339 53.0196 35.1707 52.9924 35.5057ZM39.003 33.0076H35.5057C35.1707 32.9804 34.8339 33.0264 34.5185 33.1423C34.2031 33.2583 33.9166 33.4414 33.679 33.679C33.4414 33.9166 33.2583 34.2031 33.1423 34.5185C33.0264 34.8339 32.9804 35.1707 33.0076 35.5057V39.003C33.0076 39.2681 33.1129 39.5222 33.3003 39.7096C33.4877 39.897 33.7418 40.0023 34.0068 40.0023C34.2718 40.0023 34.526 39.897 34.7134 39.7096C34.9008 39.5222 35.0061 39.2681 35.0061 39.003V35.5057C35.0061 35.057 35.058 35.0061 35.5057 35.0061H39.003C39.2681 35.0061 39.5222 34.9008 39.7096 34.7134C39.897 34.526 40.0023 34.2718 40.0023 34.0068C40.0023 33.7418 39.897 33.4877 39.7096 33.3003C39.5222 33.1129 39.2681 33.0076 39.003 33.0076ZM39.003 50.9939H35.5057C35.058 50.9939 35.0061 50.943 35.0061 50.4943V46.997C35.0061 46.7319 34.9008 46.4778 34.7134 46.2904C34.526 46.103 34.2718 45.9977 34.0068 45.9977C33.7418 45.9977 33.4877 46.103 33.3003 46.2904C33.1129 46.4778 33.0076 46.7319 33.0076 46.997V50.4943C32.9804 50.8293 33.0264 51.1661 33.1423 51.4815C33.2583 51.7969 33.4414 52.0834 33.679 52.321C33.9166 52.5586 34.2031 52.7417 34.5185 52.8577C34.8339 52.9736 35.1707 53.0196 35.5057 52.9924H39.003C39.2681 52.9924 39.5222 52.8871 39.7096 52.6997C39.897 52.5123 40.0023 52.2582 40.0023 51.9932C40.0023 51.7282 39.897 51.474 39.7096 51.2866C39.5222 51.0992 39.2681 50.9939 39.003 50.9939ZM51.9932 45.9977C51.7282 45.9977 51.474 46.103 51.2866 46.2904C51.0992 46.4778 50.9939 46.7319 50.9939 46.997V50.4943C50.9939 50.943 50.942 50.9939 50.4943 50.9939H46.997C46.7319 50.9939 46.4778 51.0992 46.2904 51.2866C46.103 51.474 45.9977 51.7282 45.9977 51.9932C45.9977 52.2582 46.103 52.5123 46.2904 52.6997C46.4778 52.8871 46.7319 52.9924 46.997 52.9924H50.4943C50.8293 53.0196 51.1661 52.9736 51.4815 52.8577C51.7969 52.7417 52.0834 52.5586 52.321 52.321C52.5586 52.0834 52.7417 51.7969 52.8577 51.4815C52.9736 51.1661 53.0196 50.8293 52.9924 50.4943V46.997C52.9924 46.7319 52.8871 46.4778 52.6997 46.2904C52.5123 46.103 52.2582 45.9977 51.9932 45.9977Z",
    fill: "#00609B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_758_15241",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870833 0 0 0 0 0.870833 0 0 0 0 0.870833 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_758_15241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_758_15241",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenCircleIcon);
export default __webpack_public_path__ + "static/media/FullScreenCircleIcon.afe947e0c137da47375343ebdd1c2b73.svg";
export { ForwardRef as ReactComponent };